package core.validation.validator

object NonEmptyListValidator : Validator<List<String>> {
    override val errorMessage: String
        get() = "This field is required."

    override fun validate(value: List<String>): Boolean {
        return value.isNotEmpty()
    }
}
